import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TenantService } from '../../../core/tenant/tenant.service';
import { Booking } from '../../booking/models/booking.models';
import { PassengerProfile } from '../models/passenger.models';

@Injectable({ providedIn: 'root' })
export class PassengerApiService {
  private readonly http = inject(HttpClient);
  private readonly tenantService = inject(TenantService);

  private get baseUrl(): string {
    return `${environment.apiUrl}/passengers`;
  }

  get operatorId(): number | null {
    return this.tenantService.operator()?.id ?? null;
  }

  getProfile(): Observable<PassengerProfile> {
    return this.http.get<PassengerProfile>(`${this.baseUrl}/me`);
  }

  getMyBookings(): Observable<Booking[]> {
    const operatorId = this.operatorId;
    if (operatorId == null) {
      return throwError(() => new Error('Operator not resolved'));
    }
    const params = new HttpParams().set('operatorId', operatorId);
    return this.http.get<Booking[]>(`${this.baseUrl}/me/bookings`, { params });
  }

  claimBooking(operatorId: number, referenceCode: string): Observable<Booking> {
    return this.http.post<Booking>(`${this.baseUrl}/me/bookings/claim`, {
      operatorId,
      referenceCode,
    });
  }

  cancelBooking(referenceCode: string, reason?: string): Observable<Booking> {
    const operatorId = this.operatorId;
    if (operatorId == null) {
      return throwError(() => new Error('Operator not resolved'));
    }
    const params = new HttpParams().set('operatorId', operatorId);
    const body =
      reason && reason.trim().length > 0 ? { reason: reason.trim() } : {};
    return this.http.post<Booking>(
      `${this.baseUrl}/me/bookings/${encodeURIComponent(referenceCode)}/cancel`,
      body,
      { params },
    );
  }
}
